import type { InitialConfigType } from '@lexical/react/LexicalComposer';
import type { EditorThemeClasses } from 'lexical';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListNode, ListItemNode } from '@lexical/list';
import { LinkNode, AutoLinkNode } from '@lexical/link';

/**
 * Billing-specific Lexical theme.
 * Professional, clean styling with dark mode support.
 */
export const invoiceLexicalTheme: EditorThemeClasses = {
  root: 'outline-none min-h-[150px] px-3 py-2 text-gray-900 dark:text-white text-sm leading-relaxed',
  paragraph: 'mb-2 text-gray-800 dark:text-gray-200',
  text: {
    bold: 'font-semibold text-gray-900 dark:text-gray-100',
    italic: 'italic',
    underline: 'underline',
    strikethrough: 'line-through',
    underlineStrikethrough: 'underline line-through',
  },
  heading: {
    h1: 'text-xl font-bold mb-3 text-gray-900 dark:text-gray-100',
    h2: 'text-lg font-semibold mb-2 text-gray-800 dark:text-gray-200',
    h3: 'text-base font-semibold mb-2 text-gray-800 dark:text-gray-200',
  },
  list: {
    ul: 'list-disc ml-6 mb-3 space-y-1',
    ol: 'list-decimal ml-6 mb-3 space-y-1',
    listitem: 'text-gray-700 dark:text-gray-300',
    nested: {
      listitem: 'text-gray-600 dark:text-gray-400',
    },
  },
  link: 'text-lex-accent underline hover:opacity-80 cursor-pointer',
  quote: 'border-l-4 border-gray-300 dark:border-gray-600 pl-4 italic text-gray-600 dark:text-gray-400 mb-3',
};

const invoiceNodes = [HeadingNode, QuoteNode, ListNode, ListItemNode, LinkNode, AutoLinkNode];

export const invoiceEditorConfig: InitialConfigType = {
  namespace: 'InvoiceMemoEditor',
  theme: invoiceLexicalTheme,
  onError: (error: Error) => {
    console.error('InvoiceMemoEditor Error:', error);
  },
  nodes: invoiceNodes,
};

export const invoiceReadOnlyConfig: InitialConfigType = {
  ...invoiceEditorConfig,
  namespace: 'InvoiceMemoReadOnly',
  editable: false,
};
